<template>
  <div />
</template>
<script>
export default {
  async asyncData(context) {
    await context.$auth.loginWith('auth0');
  },
};
</script>
